import { render } from "./BaseCard.vue?vue&type=template&id=ddc8bed4&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=ddc8bed4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Isaias\\Documents\\Vue\\EntregasApp\\Lupnova\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddc8bed4"]])

export default __exports__